import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { Classification } from '../models';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ClassificationService extends BaseApiService<Classification> {
  get cacheKey(): StorageKey {
    return StorageKey.classificationServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 'Brasil';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/classifications`;
      default:
        let url = `${environment.apiUrl}/classifications`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  protected unparse(obj) {
    return Classification.unparse(obj);
  }

  protected parse(obj) {
    return Classification.parse(obj);
  }

}
